function Answers({ answer, dispatch, question }) {
  return (
    <div className="answers">
      {question.options.map((option, index) => (
        <button
          key={index}
          className={`answers ${
            answer !== null
              ? question.correctOption === index
                ? "correct"
                : "wrong"
              : ""
          }  ${answer === index ? "selected" : ""}`}
          disabled={answer !== null}
          onClick={() =>
            dispatch({
              type: "answerQuestion",
              payload: {
                answer: index,
                point: question.correctOption === index ? question.points : 0,
              },
            })
          }
        >
          <span>{index + 1}</span>
        </button>
      ))}
    </div>
  );
}

export default Answers;
